module.exports = __webpack_public_path__ + "ee38a12c16abbf26e7587ed302bcef53.svg";